import { fromFetch } from 'rxjs/fetch';
import { getOnPageContent } from 'constants/routes'

/**
 * This function sends a POST request with search parameters to get on-page content and returns a
 * response in JSON format.
 * @param searchParameters - It is an object that contains the parameters for the location content
 * command. The specific parameters depend on the API being used, but they are likely related to
 * specifying the location and type of content to retrieve.
 * @returns an Observable from the RxJS library, which will make a POST request to the
 * `getOnPageContent` endpoint with the provided `searchParameters` as the request body. The response
 * will be converted to JSON format using the `selector` function and returned as an Observable.
 */
function getOnPageContentRequest$(contentCommandParameters) {
const requestObject = {
        method: 'POST',
        body: JSON.stringify({
          housingProductLocationContentCommand: {
            createCanonicalUrlCommand: { ...contentCommandParameters.createCanonicalUrlCommand },
            searchCommand : { ...contentCommandParameters.searchLocationCommand.searchParameters },
          },
        }),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        selector: (response) => response.json(),
      };
      return fromFetch(getOnPageContent, requestObject);
}

export default getOnPageContentRequest$;
